export function* mixins(resource) {
  // eslint-disable-next-line @typescript-eslint/ban-types
  let ctor = resource.constructor;

  while (ctor) {
    if ('__properties' in ctor) {
      yield ctor;
    }

    ctor = Object.getPrototypeOf(ctor);
  }
}